import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-EDM-add",
  "use": "icon-EDM-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EDM-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 85.312a426.688 426.688 0 1 0 0 853.312A426.688 426.688 0 0 0 512 85.312z m45.504 172.032v213.376h213.376v85.312H557.44v213.312H472.192V556.032H258.88V470.72h213.312V257.28h85.312z\" p-id=\"14166\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol